import {
	MeshBasicMaterial,
	LineBasicMaterial,
	Mesh,
	BoxGeometry,
	Object3D,
	EdgesGeometry,
	LineSegments,
} from 'three';
import {OlivioLuminaire} from './olivioLuminaire';

const conf = {
	...OlivioLuminaire.conf,
	topLinkName: 'top_link',
	poleHeight: 3.1,
	poleTopMargin: 0.1,
	poleEdgesColor: 0x555555,
};

class OlivioUniversalLuminaire extends OlivioLuminaire {
	static conf = conf;

	static designName = 'universal';

	static poleSizes = {
		fakePole: {
			height: 3,
			topMargin: 0,
			verticalAngle: 0,
			xBaseOffset: 0,
			ratio: 0
		}
	};

	static defaultConfig = {
		poleHeight: 3,
		numberOfHeads: 1,
		layout: 'none',
	};


	static models = {
		pole: null,
		bracket: {},
	};

	static modelPatterns = [
		{type: 'bracket', pattern: /^Universal_Bracket_(?<id>(Medio-Grande)|(Piccolo))$/i, storageKeys: ['id']},
	];

	static hasBrackets = true;

	static singleBracket = true;

	static supportLayouts = false;

	static checkCollisions = false;

	static defaultConfig = {
		poleHeight: 0,
		numberOfHeads: 1,
		layout: 'none',
	};

	static getPoleId(configValues) {
		return 'fakePole';
	}

	static getBracketId(configValues, index) {
		return String(configValues.housingSize).toLowerCase().includes('piccolo') ? 'piccolo' : 'medio-grande';
	}

	static getHeadAngle(index, bracketId) {
		return 0;
	}

	static getPoleModel(configValues) {
		if (!this.models.pole) {
			const geometry = new BoxGeometry(0.15, conf.poleHeight, 0.15);
			geometry.translate(-0.15 / 2, conf.poleHeight / 2, 0);
			const material = new MeshBasicMaterial({
				transparent: true,
				opacity: 0
			});
			const edgesGeometry = new EdgesGeometry(geometry);
			const lines = new LineSegments(edgesGeometry, new LineBasicMaterial({color: conf.poleEdgesColor}));
			const pole = new Mesh(geometry, material);
			pole.add(lines);
			pole.userData.design = 'universal';
			pole.userData.modelType = 'pole';
			pole.userData.id = this.getPoleId();
			const headLink = new Object3D();
			headLink.name = conf.topLinkName;
			headLink.position.set(0, conf.poleHeight - conf.poleTopMargin, 0);
			pole.add(headLink);
			this.models.pole = pole;
		}
		return this.models.pole;
	}

}

export {OlivioUniversalLuminaire};

